import { SVGProps } from 'react'

export const FilterNoBg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...props}>
    <path fill="currentColor" fillOpacity="0.95" d="M10.5 18h4v-2h-4v2zm-7-12v2h18V6h-18zm3 7h12v-2h-12v2z"></path>
  </svg>
)
